import React from 'react';

import Box from '@mui/material/Box';

const TEAL_COLOR = '#4CC3B6'; // TODO: FIXME we should add this color to theme

type Grid2x2Props = {
  topLeft: React.ReactNode;
  topRight: React.ReactNode;
  bottomLeft: React.ReactNode;
  bottomRight: React.ReactNode;
};

const Grid2x2: React.FC<Grid2x2Props> = ({
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
}) => {
  return (
    <Box
      sx={theme => ({
        display: 'grid',
        gridTemplateColumns: '200px 1fr',
        gridTemplateRows: 'auto 1fr',
        border: `2px solid ${TEAL_COLOR}`,
        borderRadius: theme.shape.borderRadius,
      })}
    >
      <Box
        sx={theme => ({
          p: 4,
          borderRight: `1px solid ${theme.palette.divider}`,
          borderBottom: `1px solid ${theme.palette.divider}`,
        })}
      >
        {topLeft}
      </Box>

      <Box sx={theme => ({ p: 4, borderBottom: `1px solid ${theme.palette.divider}` })}>
        {topRight}
      </Box>

      <Box sx={theme => ({ p: 4, borderRight: `1px solid ${theme.palette.divider}` })}>
        {bottomLeft}
      </Box>

      <Box sx={{ p: 4 }}>{bottomRight}</Box>
    </Box>
  );
};

export default Grid2x2;
